<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sales Profit Margin Report</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/sales-summary">
          <v-icon left>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div v-if="hideTotals != 'Y'">
          <v-row dense>
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete name="salesReportProductID" dense outlined :search-input.sync="searchProducts"
                v-model="record.ProductId" :items="products" label="Products" item-text="Name"
                item-value="id"></v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete name="salesTransactionsCustomer" dense outlined v-model="record.CustomerId"
                :items="customers" label="Customer" item-text="Name" item-value="id"></v-autocomplete>
            </v-col>

            <v-col cols="6" xs="6" md="12">
              <v-btn class="float-right" @click="getReport" color="primary"><v-icon
                  left>mdi-list-box-outline</v-icon>Generate
                Report</v-btn>
            </v-col>
          </v-row>

          <v-row dense class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-text-field label="Search" v-model="search"></v-text-field>
            </v-col>

            <v-col cols="12" xs="12" md="4">
              <span class="totals">Total Selling Price: {{ TotalSellingPrice | currency }}</span><br>
              <span class="totals">Total Buying Price: {{ TotalBuyingPrice | currency }}</span><br>
              <span class="totals">Total Profit: {{ TotalProfit | currency }}</span><br>


              <download-excel :data="reportData" :fields="fields" name="profit report">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>

            </v-col>

            <v-col cols="12" xs="12" md="4"> </v-col>
            <v-col cols="12">
              <v-data-table :items-per-page="2000" :mobile-breakpoint="zeroValue" :headers="headers" :items="reportData"
                :search="search">
                <template v-slot:item.BuyingPrice="{ item }">
                  {{ item.BuyingPrice | currency }}
                </template>

                <template v-slot:item.SellingPrice="{ item }">
                  {{ item.SellingPrice | currency }}
                </template>

                <template v-slot:item.LineProfit="{ item }">
                  {{ item.LineProfit | currency }}
                </template>

                <template v-slot:item.Date="{ item }">
                  {{ item.Date | date }}
                </template>

              </v-data-table>
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      pageItems: 500,
      profitReport: [],
      IMEI: null,
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      zeroValue: 0,
      products: [],
      customers: [],
      reportData: [],
      TotalProfit: 0,
      TotalSellingPrice: 0,
      TotalBuyingPrice: 0,
      searchProducts: null,
      headers: [
        { text: "Customer", value: "Customer" },
        { text: "Product", value: "Product" },
        { text: "Qty", value: "Quantity" },
        { text: "Buying Price", value: "BuyingPrice" },
        { text: "Selling Price", value: "SellingPrice" },
        { text: "Total", value: "LineTotal" },
        { text: "Profit", value: "LineProfit" },
        { text: "Date", value: "Date" },
      ],
      fields: {
        Product: "Product",
        Quantity: "Quantity",
        BuyingPrice: "BuyingPrice",
        SellingPrice: "SellingPrice",
        TotalSales: "LineTotal",
        Profit: "LineProfit",
        Date: "Date",
      },
    };
  },
  computed: {
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    },
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData.length > 0) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const data = this.record;
      const url = "/daily-profit-report";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          console.log(res, " profit report");
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData.sales;
            self.TotalProfit = res.ResponseData.totalProfit;
            self.TotalSellingPrice = res.ResponseData.totalSellingPrice;
            self.TotalBuyingPrice = res.ResponseData.totalBuyingPrice;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          self.loader = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    print() { }
  },
  created() {
    this.getCustomers();
  }
};
</script>

<style lang="scss" scoped></style>